import apiClient from '../apiClient';
import { LoginRequest, LoginResponse } from '../types/auth';

export const login = async (credentials: LoginRequest): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>('/auth/login', credentials);
  return response.data || {};
};

export const logout = async (): Promise<void> => {
  await apiClient.post('/auth/logout');
};

export const checkAuthStatus = async (): Promise<boolean> => {
  try {
    const response = await apiClient.get('/auth/status');
    return response.status === 200;
  } catch {
    return false;
  }
};
